import React from 'react';
import { Result } from 'antd';

const Notfound = () => {
  return (
    <Result
    status="404"
    title="404"
    subTitle={<span style={{fontWeight: 'bold'}}>Xin lỗi, trang bạn truy cập không tồn tại</span>}
    // extra={<Button type="primary">Back Home</Button>}
  />
  );
};

export default Notfound;